/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import PropTypes from 'prop-types';
import { cloneElement, Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { OrderedMap, List, Map as ImmutableMap } from 'immutable';
import partial from 'transmute/partial';
import debounce from 'transmute/debounce';
import { CONTENT_TYPE_FIELD } from 'SalesContentIndexUI/data/constants/SearchFields';
import SearchStatus from 'SalesContentIndexUI/data/constants/SearchStatus';
import SearchResultRecord from 'SalesContentIndexUI/data/records/SearchResultRecord';
import SearchQueryRecord from 'SalesContentIndexUI/data/records/SearchQueryRecord';
import IndexUIActions from 'SalesContentIndexUI/data/actions/IndexUIActions';
import filter from 'SalesContentIndexUI/data/utils/filter';
import DefaultSort from 'SalesContentIndexUI/data/lib/DefaultSort';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { FolderNav, FolderNavItem } from 'foundations-components/transitional/components/FolderNav';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Alert } from 'foundations-components/transitional/components/Alert';
import FolderNavSelectedCopy from './FolderNavSelectedCopy';
import FolderNavNoFolderItem from './FolderNavNoFolderItem';
import FolderNavFooter from './FolderNavFooter';
import FolderNavCreateFolder from './FolderNavCreateFolder';
import { H2 } from 'foundations-components/transitional/components/H2';
import { FolderIcon } from 'foundations-assets/icons/components/FolderIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CREATION_ERROR = 'creation';
const MOVE_ERROR = 'move';
const searchResultsToMap = results => results.reduce((searchResultsMap, result) => {
  const searchResult = SearchResultRecord.init(result);
  return searchResultsMap.set(searchResult.id, searchResult);
}, OrderedMap());
export default class FolderNavModal extends Component {
  constructor(props) {
    super(props);
    this.fetchFolders = () => {
      this.setState({
        folderSearchStatus: SearchStatus.LOADING
      });
      this.props.searchFetch(this.state.folderSearchQuery).then(resultsData => {
        const hasMore = resultsData.get('hasMore');
        const results = searchResultsToMap(resultsData.get('results'));
        this.setState(({
          folderSearchResults
        }) => ({
          hasMore,
          folderSearchResults: folderSearchResults.merge(results),
          folderSearchStatus: SearchStatus.SUCCEEDED
        }));
      });
    };
    this.fetchMoreFolders = () => {
      const {
        hasMore
      } = this.state;
      const {
        scrollTop,
        scrollHeight,
        clientHeight
      } = this._folderNav;
      const isCloseToBottom = scrollTop + clientHeight + 50 >= scrollHeight;
      if (hasMore && isCloseToBottom) {
        this.setState(({
          folderSearchQuery
        }) => ({
          folderSearchQuery: folderSearchQuery.set('offset', folderSearchQuery.offset + folderSearchQuery.limit)
        }), this.fetchFolders);
      }
    };
    this.setSelectedFolder = selectedFolder => {
      this.setState({
        selectedFolder
      });
    };
    this.isInitialFetchLoading = () => {
      const {
        hasMore,
        folderSearchStatus,
        folderSearchResults
      } = this.state;
      return folderSearchStatus === SearchStatus.LOADING && hasMore && folderSearchResults.isEmpty();
    };
    this.handleMoveClick = () => {
      const {
        searchResults,
        moveSearchResults
      } = this.props;
      const {
        selectedFolder: {
          name: folderName,
          contentId
        }
      } = this.state;
      const contentIds = searchResults.map(searchResult => searchResult.contentId);
      const ids = searchResults.map(searchResult => searchResult.id);
      const count = contentIds.size;
      const newFolderId = contentId === 0 ? null : contentId;
      const folderWillNotChange = searchResults.every(searchResult => searchResult.folderId === newFolderId);
      if (folderWillNotChange) {
        this.props.onReject();
        return;
      }
      this.setState({
        alertType: null
      });
      moveSearchResults(contentIds, newFolderId, folderName, searchResults).then(() => {
        IndexUIActions.removeResults(ids);
        this.props.onConfirm({
          name: folderName,
          count
        });
      }, () => {
        this.setState({
          alertType: MOVE_ERROR
        });
      });
    };
    this.handleSaveFolder = () => {
      const {
        saveFolder
      } = this.props;
      const {
        folderName
      } = this.state;
      this.setState({
        createFolderOpen: false,
        alertType: null,
        isSavingFolder: true
      });
      saveFolder({
        name: folderName
      }).then(folderSearchResult => {
        this.setState(({
          folderSearchResults
        }) => ({
          folderName: '',
          isSavingFolder: false,
          folderSearchResults: OrderedMap({
            [folderSearchResult.id]: folderSearchResult
          }).merge(folderSearchResults)
        }));
      }, () => {
        this.setState({
          alertType: CREATION_ERROR,
          isSavingFolder: false
        });
      });
    };
    this.setFolderSearchQuery = ({
      target: {
        value
      }
    }) => {
      this.setState(({
        folderSearchQuery
      }) => ({
        hasMore: true,
        folderSearchResults: OrderedMap(),
        folderSearchQuery: folderSearchQuery.merge({
          query: value,
          offset: 0
        }),
        folderSearchStatus: SearchStatus.LOADING
      }), this.debouncedFetchFolders);
    };
    this.renderAlert = () => {
      const {
        alert
      } = this.props;
      if (!alert) {
        return null;
      }
      return /*#__PURE__*/cloneElement(alert, {
        className: 'm-bottom-4',
        use: 'inline'
      });
    };
    this.renderError = () => {
      const {
        alertType
      } = this.state;
      if (!alertType) {
        return null;
      }
      return /*#__PURE__*/_jsx(Alert, {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `salesContentIndexUI.folderModal.error.${alertType}.title`
        }),
        type: "danger",
        use: "inline",
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `salesContentIndexUI.folderModal.error.${alertType}.message`
        })
      });
    };
    this.renderFolderLoading = () => {
      if (!this.state.hasMore && !this.state.isSavingFolder) {
        return null;
      }
      return /*#__PURE__*/_jsx(TFlex, {
        align: "center",
        children: /*#__PURE__*/_jsx(LoadingSpinner, {
          grow: true,
          minHeight: 50
        })
      });
    };
    this.renderFolders = () => {
      if (this.isInitialFetchLoading() || this.state.isSavingFolder) {
        return null;
      }
      return this.state.folderSearchResults.map(folderSearchResult => {
        return /*#__PURE__*/_jsx(FolderNavItem, {
          open: false,
          value: folderSearchResult.contentId,
          title: folderSearchResult.name,
          onClick: partial(this.setSelectedFolder, folderSearchResult),
          iconLeft: FolderIcon
        }, `folder-nav-item-${folderSearchResult.contentId}`);
      }).toList();
    };
    this.debouncedFetchFolders = debounce(300, this.fetchFolders);
    this.state = {
      folderName: '',
      isSavingFolder: false,
      createFolderOpen: false,
      createFolderError: false,
      selectedFolder: null,
      folderSearchResults: OrderedMap(),
      folderSearchQuery: new SearchQueryRecord({
        offset: 0,
        limit: 20,
        filters: List([filter(CONTENT_TYPE_FIELD, props.folderContentType)]),
        sorts: List([DefaultSort])
      }),
      hasMore: true,
      folderSearchStatus: SearchStatus.LOADING
    };
  }
  componentDidMount() {
    this.fetchFolders();
    this._folderNav = document.querySelector('[data-test-id="move-data-item-modal-folder-nav"]');
    this._folderNav.addEventListener('scroll', this.fetchMoreFolders);
  }
  componentWillUnmount() {
    this._folderNav.removeEventListener('scroll', this.fetchMoreFolders);
  }
  render() {
    const {
      selectedFolder,
      folderSearchQuery
    } = this.state;
    const {
      searchResult,
      searchResults,
      saveFolder,
      onReject
    } = this.props;
    return /*#__PURE__*/_jsxs(Modal, {
      size: "auto",
      onEsc: onReject,
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: onReject
        }), /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "salesContentIndexUI.tableRowHoverButtons.moveFolders"
          })
        })]
      }), /*#__PURE__*/_jsxs(DialogBody, {
        children: [this.renderAlert(), this.renderError(), /*#__PURE__*/_jsx(SearchInput, {
          value: folderSearchQuery.query,
          onChange: this.setFolderSearchQuery,
          marginBlockEnd: "300"
        }), /*#__PURE__*/_jsx(FolderNavSelectedCopy, {
          searchResult: searchResult,
          searchResults: searchResults,
          selectedFolder: selectedFolder
        }), /*#__PURE__*/_jsxs(FolderNav, {
          value: selectedFolder && selectedFolder.contentId,
          "data-test-id": "move-data-item-modal-folder-nav",
          children: [/*#__PURE__*/_jsx(FolderNavNoFolderItem, {
            isInitialFetchLoading: this.isInitialFetchLoading(),
            setSelectedFolder: this.setSelectedFolder
          }), this.renderFolders(), this.renderFolderLoading()]
        })]
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        paddingBlockStart: "0",
        children: [/*#__PURE__*/_jsx(FolderNavCreateFolder, {
          folderName: this.state.folderName,
          createFolderOpen: this.state.createFolderOpen,
          saveFolder: saveFolder,
          onSaveFolder: this.handleSaveFolder,
          onFolderOpenChange: createFolderOpen => this.setState({
            createFolderOpen
          }),
          onFolderNameChange: folderName => this.setState({
            folderName
          })
        }), /*#__PURE__*/_jsx(FolderNavFooter, {
          onConfirm: this.handleMoveClick,
          onClose: onReject,
          selectedFolder: selectedFolder
        })]
      })]
    });
  }
}
FolderNavModal.propTypes = {
  searchResult: PropTypes.instanceOf(SearchResultRecord),
  searchResults: PropTypes.instanceOf(ImmutableMap),
  folderContentType: PropTypes.string.isRequired,
  searchFetch: PropTypes.func.isRequired,
  saveFolder: PropTypes.func.isRequired,
  moveSearchResults: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  alert: PropTypes.element
};